import styled from 'styled-components';
const Container = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.65);
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 100;
`;
export default {
    Container,
};
